// Theme bootstrap — thin wrapper around @mamamiya/brand's ThemeProvider.
//
// Responsibilities:
// - Construct the single ThemeProvider instance used by this app.
// - Inject fetchers that hit admin-api (active brand palette) and customer-api
//   (signed-in customer UI preferences). Both are best-effort: bundled default
//   tokens from @mamamiya/brand/themes/default-{dark,light} render immediately
//   even if these calls fail.
// - Expose bootTheme() so main.js can fire-and-forget the async boot.

import { ThemeProvider } from "@mamamiya/brand/runtime";

const ADMIN_API = import.meta.env.VITE_ADMIN_API ?? "https://admin-api.mamamiya.store";

async function fetchActivePalette() {
  const res = await fetch(`${ADMIN_API}/api/themes/active`, { credentials: "omit" });
  if (!res.ok) throw new Error(`active palette ${res.status}`);
  const body = await res.json();
  return body.data?.tokens ?? body.data;
}

async function fetchCustomerPrefs() {
  // NO backend exists for /api/customer/ui-prefs (route-map: not on any
  // worker) — every authed boot 404ed. Short-circuit until the prefs
  // endpoint ships; ThemeProvider treats null as "use local/default prefs".
  return null;
}

export const themeProvider = new ThemeProvider({ fetchActivePalette, fetchCustomerPrefs });

export function bootTheme() {
  // creatorHUB is a LIGHT workspace (bao 2026-10-24: one page, one surface —
  // the 2026-06-16 dark-only ruling is archived; the dark palette stays in
  // @mamamiya/brand/themes/default-dark.css for storefront/admin). Force
  // light BEFORE boot so there's no dark flash: existing users with a stored
  // theme_mode="dark" pref get migrated by this setMode (it persists light).
  themeProvider.setMode("light");
  return themeProvider.boot();
}
